import { type CodeSystemsCptCodesListResponse } from '@fireflyhealth/api'

// Sourced from the generated CPT-code response (the /code-systems/cpt-codes/ and
// /code-systems/search/ endpoints share the CPTCodeSerializer shape) so the type
// stays in sync with the backend; we Pick only the fields the UI consumes.
export type CPTCode = Pick<
  CodeSystemsCptCodesListResponse[number],
  'id' | 'code' | 'display' | 'description'
>

export const ProviderRecommendationStatus: Record<string, string | undefined> = {
  RECOMMENDED: 'Recommended',
  NOT_RECOMMENDED: 'Not Recommended',
  NEUTRAL: 'Neutral',
}
